<template>
  <button
    class="border rounded-sm px-1 py-0.5 border-gray-300 bg-gray-100 enabled:hover:bg-gray-200 enabled:active:bg-gray-300 disabled:text-gray-400"
  >
    <slot />
  </button>
</template>
